import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../InputText/InputText';

const InputTextArea = ({ hint, required, label, ...props }) => (
  <InputText {...props} hint={hint} required={required} label={label} multiline rows={8} />
);

InputTextArea.propsTypes = {
  required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
};

InputTextArea.defaultProps = {
  hint: null,
};

export default InputTextArea;
